var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUserBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AddUsers_Outline_24px",
    transform: "translate(-0.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1173",
    "data-name": "Rectangle 1173",
    width: 22,
    height: 22,
    transform: "translate(1.02 1.13)",
    fill: "#e8e8e8",
    stroke: "#231f20",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1174",
    "data-name": "Rectangle 1174",
    width: 24,
    height: 24,
    transform: "translate(0.02)",
    fill: "#165cf3",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 22,
    height: 22,
    transform: "translate(1.27 1.25)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "add-circle",
    d: "M5.97,13.22a4.5,4.5,0,1,0,4.5,4.5,4.494,4.494,0,0,0-4.5-4.5ZM7.7,18.07H6.32v1.38a.35.35,0,1,1-.7,0V18.07H4.24a.35.35,0,0,1,0-.7H5.62V15.99a.35.35,0,1,1,.7,0v1.38H7.7a.35.35,0,0,1,0,.7h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M15.02,19.25a9.444,9.444,0,0,0,6.75-.58V18.5a4.119,4.119,0,0,0-7.53-2.32",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 3.37,
    cy: 3.37,
    r: 3.37,
    transform: "translate(5.28 3.13)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M3.34,15.72a6.379,6.379,0,0,1,10.9.47",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M15.02,19.25v.11a12.371,12.371,0,0,1-6.73,1.76",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M15.02,19.25h0a6.35,6.35,0,0,0-.79-3.07",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M17.16,11.33a2.622,2.622,0,0,1,.48-5.2h0a2.628,2.628,0,0,1,2.57,2.08",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(19.08 10)",
    fill: "#787f88",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserBtnIcon);
export default __webpack_public_path__ + "static/media/add-user-btn-icon.860bebf4e017e744791e32e75f1d7da6.svg";
export { ForwardRef as ReactComponent };